import httpsService from "src/api/httpsService";
import { API_PATH } from "../const/api-urls";
import { BaseResponse } from "../interface/index";
import { IResponseInquiryPolicy } from "../interface/inquiryPolicy/responseInquiryPolicy";
import { IRequestInquiryPolicy } from "../interface/inquiryPolicy/requestInquiryPolicy";
import DateFns from 'src/utils/DateFns';
import { createCreDtTm, createMSGID } from "src/utils/helper";
import { DatePattend } from "src/utils/DatePattend";
import { FR_HEADER, TO_HEADER } from "src/const/const-from-env";
import { DefaultHeaderFrSystm, DefaultHeaderToSystm } from "src/const";

interface PropsI {
  documentPerson: string;
  bornPeopleBuyInsurance: string;
  bornPeopleUseInsurance: string;
}
export const QueryInquiryPolicy = (body: PropsI,tokenCaptcha:string, frSystm?: string) => {
  const phDoB =  DateFns.formatDateTime(new Date(body.bornPeopleBuyInsurance),DatePattend.YearMonthDay)
  const laDoB =  DateFns.formatDateTime(new Date(body.bornPeopleUseInsurance),DatePattend.YearMonthDay)
  const convertPhDoB = phDoB.replaceAll("/","-")
  const convertLhDoB = laDoB.replaceAll("/","-")

  const convertBody = {
    idNumber: body.documentPerson,
    phDoB: convertPhDoB,
    laDoB: convertLhDoB,
  };
  const param = { msgId: createMSGID(FR_HEADER) };
  const header = {
    frSystm: frSystm ? frSystm : DefaultHeaderFrSystm,
    toSystm: DefaultHeaderToSystm,
    creDtTm: createCreDtTm(),
    tokenCaptcha:tokenCaptcha || ""
  };

  return httpsService.post<
    IRequestInquiryPolicy,
    BaseResponse<IResponseInquiryPolicy>
  >(API_PATH.INQUIRY_POLICY, convertBody, { headers: header, params: param });
};
